import { FoundColumn, StreamDataColumn } from '@squaredup/data-streams';
import { PrefixedBuiltinValue, valuePrefix } from './valuePrefix';

export type Option = {
    label: string;
    value: string | PrefixedBuiltinValue;
};

export type OptionGroups = {
    label: string;
    options: Option[];
};

function createColumnOption(column: StreamDataColumn): Option {
    return {
        label: column.displayName,
        value: valuePrefix.addPrefix.column(column.name)
    };
}

function createBuiltInOptions(autoName: string, hasAutoColumn: boolean): Option[] {
    const { VALUES } = valuePrefix;
    const builtInOptions: Option[] = [
        {
            label: autoName,
            value: VALUES.NONE
        }
    ];

    if (hasAutoColumn) {
        builtInOptions.push({
            label: 'Count (rows)',
            value: VALUES.COUNT
        });
    }

    return builtInOptions;
}

export function createOptionGroups(columns: StreamDataColumn[], autoColumn?: FoundColumn): OptionGroups[] {
    const autoName = autoColumn?.column ? `Auto - ${autoColumn.column.displayName}` : 'Auto - Count (rows)';

    // Filter out the auto-selected column from the columns list to avoid duplication
    const filteredColumns = autoColumn?.column
        ? columns.filter((column) => column.name !== autoColumn.column.name)
        : columns;

    return [
        {
            label: 'Built-in',
            options: createBuiltInOptions(autoName, Boolean(autoColumn?.column))
        },
        {
            label: 'Columns',
            options: filteredColumns.map(createColumnOption)
        }
    ];
}
